import React from "react";
import styled from "styled-components/macro";
import { Button as MuiButton } from "@mui/material";
import { spacing, SpacingProps } from "@mui/system";

interface ButtonProps extends SpacingProps {
  component?: React.ElementType;
  to?: string;
  target?: string;
}

const Button: any = styled(MuiButton)`
  margin-top: 11px;
  color: #223354;
  &.blue_button {
    background-color: blue;
  }

  &.custom_disabled {
    background-color: grey !important;
  }
`;

interface ButtonProps {
  children: any;
  callBack: any;
  styles?: any;
  disabled?: boolean;
}
const CustomButton: React.FC<ButtonProps> = ({
  children,
  callBack,
  styles = {},
  disabled = false
}) => {
  return (
    <Button
      variant="contained"
      color="secondary"
      className={disabled ? "blue_button custom_disabled" : "blue_button"}
      onClick={disabled ? () => {} : callBack}
      sx={styles}
      disabled={disabled}
    >
      {children}
    </Button>
  );
};

export default CustomButton;
